import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import routerEnvConfig from '@/router/setup/siteRouterEnv'
import loader from '@/utils/loader'

// request interceptor
axios.interceptors.request.use(
  config => {
    // do something before request is sent

    if (store.getters.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers['X-token'] = store.getters.token
    }

    const tempRouterEnvConfig = routerEnvConfig.get()
    if (tempRouterEnvConfig) {
      config.headers['X-scope'] = tempRouterEnvConfig.id
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
axios.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data

    // if the custom code is not 20000, it is judged as an error.
    if (res && res.code && res.code !== 20000) {
      Message({
        message: res.message || 'Error',
        type: 'error',
        duration: 5 * 1000
      })

      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        // to re-login
        MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
          confirmButtonText: 'Re-Login',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          store.dispatch('user/resetToken').then(() => {
            location.reload()
          })
        })
      }
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  },
  error => {
    const err = error.response || ({ data: { message: error }})
    console.log('response-err：', err) // for debug
    Message({
      message: (err.data.message || err.data) || err,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(err)
  }
)

/**
 * @param { Ocject } opt
 * @returns { Ocject } promise
 */
const service = (opt) => {
  if (!opt || !opt.url) {
    Message({
      message: '请确认访问地址！' || 'Error',
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject('请确认访问地址！')
  } else {
    // 加载
    const tempLoad = loader()

    if (!opt.baseURL) opt.baseURL = process.env.VUE_APP_BASE_API

    // 请求方式
    if (!opt.method) opt.method = 'GET'

    // post请求参数
    if (!opt.data) opt.data = {}

    // get请求参数
    if (!opt.params) opt.params = {}

    const _axios = axios({
      baseURL: opt.baseURL,
      method: opt.method,
      url: opt.url,
      timeout: 200000,
      data: opt.data,
      params: opt.params
      // withCredentials: true, // send cookies when cross-domain requests
    })

    _axios.finally(() => {
      tempLoad.close()
    })

    return _axios
  }
}

export default service
